import { render, staticRenderFns } from "./MarketStartupsModal.vue?vue&type=template&id=eeca3d4a&scoped=true&"
import script from "./MarketStartupsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./MarketStartupsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeca3d4a",
  null
  
)

export default component.exports